"use strict";

const SortUtilities = function () {
  const localComparer = new Intl.Collator(undefined, {
    numeric: true,
    sensitivity: "base",
  });

  var sortRows = function (key, reversed, rows, sortersDict) {
    if (!key) {
      return;
    }

    const compare = _getCompareFunction(key, reversed, sortersDict);
    rows.sort((item1, item2) => compare(item1, item2));
  };

  var _getCompareFunction = function (key, reversed, sortersDict) {
    const sortFunction = _getSortFunction(key, reversed, sortersDict);
    const valueFunction = _getValueFunction(key);

    return (item1, item2) => {
      const value1 = valueFunction(item1);
      const value2 = valueFunction(item2);
      const result = sortFunction(value1, value2);

      if (result === 0 && item1.id && item2.id) {
        const tieBreaker = numberSorter(item1.id, item2.id);
        return reversed ? -tieBreaker : tieBreaker;
      }
      return result;
    };
  };

  var _getSortFunction = function (key, reversed, sortersDict) {
    let sortFunction = sortersDict[key];

    if (!sortFunction) {
      throw new Error(`Sorting key ${key} not known in sortersDict`);
    } else if (reversed) {
      sortFunction = (item1, item2) => -sortersDict[key](item1, item2);
    }

    return sortFunction;
  };

  var _getValueFunction = function (key) {
    if (key.includes(".")) {
      const paths = key.split(".");
      return (item) => getMultiLevelKeyValue(paths, item);
    } else {
      return (item) => item[key];
    }
  };

  var getMultiLevelKeyValue = function (paths, obj) {
    return paths.reduce((acc, path) => {
      if (!acc) {
        return null;
      }
      return acc[path];
    }, obj);
  };

  var numberSorter = function (x, y) {
    return undefinedSort(x, y) ?? +x - +y;
  };

  var alphaSorter = function (str1, str2) {
    return undefinedSort(str1, str2) ?? localStringSort(str1, str2);
  };

  var localStringSort = function (str1, str2) {
    return localComparer.compare(str1.trim(), str2.trim());
  };

  var booleanSorter = function (bool1, bool2) {
    return undefinedSort(bool1, bool2) ?? (bool1 === bool2 ? 0 : bool1 ? 1 : -1);
  };

  var undefinedSort = function (item1, item2) {
    if (item1 === undefined || item1 === null) {
      if (item2 === undefined || item2 === null) {
        return 0;
      }
      return -1;
    }

    if (item2 === undefined || item2 === null) {
      return 1;
    }

    return null;
  };

  var cofSorter = function (str1, str2) {
    const cofOrders = ["unknown", "very-low", "low", "moderate", "high", "very-high"];

    return undefinedSort(str1, str2) ?? cofOrders.indexOf(str1) - cofOrders.indexOf(str2);
  };

  var arrayQuantitySort = function (array1, array2, tieSortFunction = null) {
    if (array1.length !== array2.length) {
      return array1.length - array2.length;
    }

    if (tieSortFunction) {
      for (let i = 0; i < array1.length; i++) {
        const result = tieSortFunction(array1[i], array2[i]);
        if (result !== 0) {
          return result;
        }
      }
    }

    return 0;
  };

  const alphaSortForceEnd = function (a, b, forceEnd = ["No Data"]) {
    return _alphaSortForceEndWithValues(a, b, a, b, forceEnd);
  };

  const alphaSortFormOptions = function (a, b, forceEndValue = [null, "unknown", "other"]) {
    return _alphaSortForceEndWithValues(a.name, b.name, a.value, b.value, forceEndValue);
  };

  const _alphaSortForceEndWithValues = function (aName, bName, aValue, bValue, forceEndValue) {
    const forceAEnd = forceEndValue.includes(aValue);
    const forceBEnd = forceEndValue.includes(bValue);

    if (forceAEnd && !forceBEnd) {
      return 1;
    } else if (!forceAEnd && forceBEnd) {
      return -1;
    }

    return alphaSorter(aName, bName);
  };

  return {
    numberSorter,
    alphaSorter,
    alphaSortForceEnd,
    alphaSortFormOptions,
    booleanSorter,
    sortRows,
    cofSorter,
    arrayQuantitySort,
    undefinedSort,
  };
};

module.exports = SortUtilities();
